// True when an Apollo / GraphQL error carries any of the auth-deny
// extension codes the backend emits. The global error link in
// apollo-client.ts already shows a centralized toast for these, so
// per-mutation catch blocks should skip their own generic "Failed
// to …" toast when this returns true.
//
// Duck-types on the error-list property rather than an `instanceof`
// check — different Apollo entry points (`@apollo/client` vs
// `@apollo/client/errors`) can produce class-identity drift across
// bundlers, and we just need to read the extensions. The list lives at
// `errors` on Apollo's `CombinedGraphQLErrors`; `graphQLErrors` is also
// read for callers that assemble the shape by hand.
export const FORBIDDEN_CODES = new Set([
  "FORBIDDEN",
  "FORBIDDEN_ROLE",
  "FORBIDDEN_ACCESS",
  "FORBIDDEN_VISIBILITY",
]);

export function isForbiddenError(err: unknown): boolean {
  if (!err || typeof err !== "object") return false;
  const candidate = err as {
    errors?: ReadonlyArray<unknown>;
    graphQLErrors?: ReadonlyArray<unknown>;
  };
  const errors = candidate.graphQLErrors ?? candidate.errors;
  if (!Array.isArray(errors)) return false;
  return errors.some((e) => {
    const code = (e as { extensions?: { code?: unknown } })?.extensions?.code;
    return typeof code === "string" && FORBIDDEN_CODES.has(code);
  });
}
